import React from 'react';
import { Sparkles, Loader2, Coins, Clock } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';

export const BudgetSummary = ({ estimate, testId = 'budget-summary' }) => {
  if (!estimate) return null;
  return (
    <div className="grid grid-cols-2 gap-3" data-testid={testId}>
      <div className="rounded-lg bg-amber-50 border border-amber-200 p-3">
        <p className="text-[11px] uppercase tracking-wider text-amber-700 flex items-center gap-1"><Coins className="w-3 h-3" /> Estimated AI credits</p>
        <p className="text-xl font-semibold text-amber-900" data-testid={`${testId}-cost`}>${estimate.estimated_cost_usd.toFixed(2)}</p>
        <p className="text-[11px] text-amber-700">{estimate.scene_count} image{estimate.scene_count === 1 ? '' : 's'} × ${estimate.cost_per_image_usd.toFixed(2)}</p>
      </div>
      <div className="rounded-lg bg-neutral-50 border p-3">
        <p className="text-[11px] uppercase tracking-wider text-neutral-500 flex items-center gap-1"><Clock className="w-3 h-3" /> Estimated time</p>
        <p className="text-xl font-semibold" data-testid={`${testId}-time`}>~{estimate.estimated_minutes} min</p>
        <p className="text-[11px] text-neutral-500">runs in the background</p>
      </div>
    </div>
  );
};

// Generic "are you sure" with a cost estimate before any bulk AI generation.
export const BudgetConfirmDialog = ({ open, onOpenChange, title, description, estimate, loading, onConfirm, confirming }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="budget-confirm-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><Sparkles className="w-5 h-5 text-amber-600" /> {title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </DialogHeader>
      {loading ? <div className="flex justify-center py-6"><Loader2 className="w-6 h-6 animate-spin text-amber-600" /></div> : <BudgetSummary estimate={estimate} />}
      {estimate && estimate.scene_count === 0 && <p className="text-sm text-neutral-500">Nothing to generate — all requested scenes already exist.</p>}
      <DialogFooter>
        <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="budget-confirm-cancel">Cancel</Button>
        <Button onClick={onConfirm} disabled={loading || confirming || !estimate || estimate.scene_count === 0} className="bg-amber-600 hover:bg-amber-700 gap-2" data-testid="budget-confirm-ok">
          {confirming ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
          {estimate ? `Generate ${estimate.scene_count} for ~$${estimate.estimated_cost_usd.toFixed(2)}` : 'Generate'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default BudgetConfirmDialog;
